import React from 'react';
import style from '../style.module.less';
import { testId } from 'ui-components/services/testid-service';
import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';
import PropTypes from 'prop-types';
import { useProductCatalogFeatureGate } from '../../../feature-gates/use-product-catalog-feature-gate';

const ItemName = ({ productId, name = '', onNameClicked }) => {
  const { isFeatureEnabled: isEditProductEnabled, disabledMessage: productLinkDisabledMessage } = useProductCatalogFeatureGate();
  if (!productId) {
    return (
      <div className={style['item-name']} {...testId('item-name-display')}>
        {name}
      </div>
    );
  }

  return (
    <div className={style['item-name']} {...testId('item-name-display')}>
      <Button
        disabled={!isEditProductEnabled}
        disabledTooltipMessage={<Text textType={TextType.Paragraph} value={productLinkDisabledMessage} />}
        onClick={onNameClicked}
        theme='link'
      >
        {name}
      </Button>
    </div>
  );
};

ItemName.propTypes = {
  productId: PropTypes.number,
  name: PropTypes.string,
  onNameClicked: PropTypes.func.isRequired,
};

export default ItemName;
